// extracted by mini-css-extract-plugin
module.exports = {"global_container":"App_global_container__DUbay"};